import {createApp} from 'vue'
import Store from 'store'
import options from './VideoComponent.options'

const component = createApp(options).use(Store)

const el = '.nlx-component--video-component'
const DOM = document.querySelector(el)

if(DOM){
    const template = DOM.outerHTML
    options.template = template


    component.mount(el)
}

